import React from "react";

type PageContainerProps = {
  children: React.ReactNode;
};

export default function PageContainer({ children }: PageContainerProps) {
  return (
    <main className="app-shell-page">
      <div className="app-shell-page__inner">{children}</div>
    </main>
  );
}